var _defs, _g;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgCover1(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    width: 786.013,
    height: 519,
    viewBox: "0 0 786.013 519",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, ".a,.f{fill:#fff;}.a,.b{stroke:#707070;}.b{fill:#ffc421;}.c{clip-path:url(#a);}.d{clip-path:url(#b);}.e,.h{fill:#1d99b3;}.g{fill:url(#c);}.h{opacity:0.42;}.i{fill:url(#d);}.j{fill:#405c96;}.k{fill:#cae6f2;}.l{fill:#002b6a;}.m{fill:url(#e);}.n{fill:url(#f);}.o{fill:#9fcdde;}.p{fill:#74428d;}.q{fill:url(#g);}.r{fill:#12426d;}.s{fill:#54a0d4;}.t{fill:url(#h);}"), /*#__PURE__*/React.createElement("clipPath", {
    id: "a"
  }, /*#__PURE__*/React.createElement("rect", {
    className: "a",
    width: 786.013,
    height: 519,
    transform: "translate(738.802 160)"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "b"
  }, /*#__PURE__*/React.createElement("path", {
    className: "b",
    d: "M791.714,391.989l-468.169-5.057L71.617,138.374,17.506,88.667V61.433L71.617.858,316.182-245.658l466.13-7.23Z",
    transform: "translate(-17.506 252.888)"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "c",
    x1: 0.5,
    y1: 0.037,
    x2: 0.5,
    y2: 0.897,
    gradientUnits: "objectBoundingBox"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#fff"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#1d99b3"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "d",
    y1: 0.804,
    y2: -0.44,
    xlinkHref: "#c"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "e",
    x1: 2.416,
    y1: -0.045,
    x2: 0.229,
    y2: 0.58,
    gradientUnits: "objectBoundingBox"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#9fc7d4"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#fff"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "f",
    x1: 1.073,
    y1: 0.415,
    x2: 0.421,
    y2: 0.495,
    xlinkHref: "#e"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "g",
    x1: -21.503,
    y1: 2.61,
    x2: -20.899,
    y2: 2.19,
    gradientUnits: "objectBoundingBox"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#72aeca"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#cae6f2"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "h",
    y1: 0.499,
    x2: 1,
    y2: 0.499,
    gradientUnits: "objectBoundingBox"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#fff",
    stopOpacity: 0
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.504,
    stopColor: "#1a4570",
    stopOpacity: 0.969
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#12426d"
  })))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    className: "c",
    transform: "translate(-738.802 -160)"
  }, /*#__PURE__*/React.createElement("g", {
    className: "d",
    transform: "translate(783.226 95.842)"
  }, /*#__PURE__*/React.createElement("g", {
    transform: "translate(148.589 19.158)"
  }, /*#__PURE__*/React.createElement("rect", {
    className: "e",
    width: 728.198,
    height: 591.198,
    transform: "translate(-137)"
  }), /*#__PURE__*/React.createElement("g", {
    transform: "translate(176.079 104.478)"
  }, /*#__PURE__*/React.createElement("path", {
    className: "f",
    d: "M304.262,315.858H425.113l27.466,219.728L340.1,537.254l-63.3-1.668Z",
    transform: "translate(-268.377 -156.833)"
  }), /*#__PURE__*/React.createElement("ellipse", {
    className: "f",
    cx: 95.674,
    cy: 95.674,
    rx: 95.674,
    ry: 95.674,
    transform: "matrix(-0.007, -1, 1, -0.007, 1.278, 192.622)"
  })), /*#__PURE__*/React.createElement("path", {
    className: "g",
    d: "M162.8,687.164H406.68V605.691L175.535,578.969,0,579.18Z",
    transform: "translate(184.518 -95.966)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "h",
    d: "M302.377,534.108l32.288,3.426L308.534,328.295H276.8Z",
    transform: "translate(25.616 -54.416)"
  }), /*#__PURE__*/React.createElement("g", {
    transform: "translate(256.457 105.115)"
  }, /*#__PURE__*/React.createElement("path", {
    className: "i",
    d: "M345.1,294.782l0-.018H313.449a95.662,95.662,0,0,0-46.015-167.431A95.675,95.675,0,0,1,345.1,294.782Z",
    transform: "translate(-267.434 -126)"
  })), /*#__PURE__*/React.createElement("path", {
    className: "e",
    d: "M322.686,646.532,214.72,619.692c18.281,10.236,51.112,28.9,62.251,37.1,15.739,6.651,23.148,12.192,26.622,15.83l19.093,7.419v6.531H203.944l-28.1-12.5-31.323,12.5H125.316c-.079-.534,2.042-1.623,3.667-1.489.956-.365,6.275-2.348,6.622-2.452l-2.149-.927s18.856-11.1,25.282-14.791,26.675,3.439,26.675,3.439l43.28,11.775a38.5,38.5,0,0,1,10.557-12.743c-1.905-5.146-3.46-8.614-3.46-8.614l3.917.088.209.037c-1.031-.883-2.156-1.849-3.36-2.879l-111.729-32.2L21.213,580.466l-.561-.3-9.8-2.4s-8.39-1.259-8.789-1.3A3.083,3.083,0,0,1,0,575.517l6.287-.127,9.648,1.5-2.308-1.426,4.86-.06,6.737,3.908.005-.008s75.312,27.417,99.291,37.534c45.6,12.3,68.175,16.221,88.042,20.493-13.43-11.639-26.732-23.317-31.273-27.77a.269.269,0,0,0-.034-.038l-.078-.024.028-.03c-9.506-9.422,7.95-7.705,9.867-7.491l.058-.036L322.686,640.9Z",
    transform: "translate(268.512 -95.373)"
  }), /*#__PURE__*/React.createElement("g", {
    transform: "translate(214.291 231.636)"
  }, /*#__PURE__*/React.createElement("path", {
    className: "j",
    d: "M222.807,450.07l-2.5-6.288,20.026-16.537,3.489,7.731Z",
    transform: "translate(-50.698 -302.453)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "k",
    d: "M448.2,350.582a9.352,9.352,0,0,1-2.071-1.51c-.634-.674-4.853-8.919-4.853-8.919a2.212,2.212,0,0,0-.435,3.025c1.052,1.876.35,2.477.35,2.477s-3.51-1.2-4.746-1.631c-2.227-.884-3.194-1.3-4.742-1.273a6.473,6.473,0,0,0-1.236,2.144c-.053.421,1.608,1.281,3.533,2.474-1.076-.323-3.651-1.569-3.9-.492a43.141,43.141,0,0,0,4.607,2.334c.536.311,2.633,1.44,4.511,2.294a23.811,23.811,0,0,0,4.7,1.355L446,354.121A13.388,13.388,0,0,0,448.2,350.582Z",
    transform: "translate(-430.102 -288.017)"
  }), /*#__PURE__*/React.createElement("g", {
    transform: "translate(14.734)"
  }, /*#__PURE__*/React.createElement("g", {
    transform: "translate(213.14 14.257)"
  }, /*#__PURE__*/React.createElement("g", {
    transform: "translate(0 18.809)"
  }, /*#__PURE__*/React.createElement("path", {
    className: "l",
    d: "M169.274,317.921l-4.215-.626-.393.172c-.194.085-4.8,2.163-5.727,8.89-.919,6.642,2.036,9.6,2.161,9.7l.339.322,4.779.783.482-2.958-3.763-.613c-.5-.744-1.582-2.85-1.036-6.823.568-4.094,2.784-5.843,3.634-6.37l3.307.485Z",
    transform: "translate(-152.689 -317.295)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "k",
    d: "M162.6,325.927l.561.34a2.323,2.323,0,0,1,.948,1.013c.562,1.538,3.436,3.463,4.184,7.719,1.693-.4.992-2.723.638-4.938.279-.2.744-.089,1.332.125a4.14,4.14,0,0,1,1.477.727,9.109,9.109,0,0,0,.43,1.959,6.908,6.908,0,0,0,1.7.234c.606.061,1.8-.137,1.451-1.513-.308-1.224.583-1.533.658-2.186s-.483-1.46-.163-2.136c.452-.944-.408-1.668-1.263-2.221a38.128,38.128,0,0,0-4.474-2.129,14.572,14.572,0,0,0-4.059-.852l-2.133-.642Z",
    transform: "translate(-162.599 -317.98)"
  })), /*#__PURE__*/React.createElement("g", {
    transform: "translate(10.154)"
  }, /*#__PURE__*/React.createElement("path", {
    className: "j",
    d: "M135.835,296.642l12.572,1.772-.181,29.837-9.048,28.637-12.264-1.727Z",
    transform: "translate(-115.405 -295.062)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "l",
    d: "M126.171,359.947l9.2-58.482-23.038-3.24-.311,30.08-8.884,28.4Z",
    transform: "translate(-82.53 -295.325)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "l",
    d: "M151.738,355.855l8.949-28.213.247-30.263-18.67-2.63-9.195,58.483Z",
    transform: "translate(-133.07 -294.749)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "f",
    d: "M132.059,337.145l.993-6.265-5.953-.867-.985,6.269Z",
    transform: "translate(-99.383 -300.594)"
  }))), /*#__PURE__*/React.createElement("path", {
    className: "j",
    d: "M285.236,378.788s-16.105-2.612-40.267,8.338c-25.491,11.541-74.522-30.2-74.522-30.2s84.891,9.285,109.444,15.63C286.49,374.254,285.236,378.788,285.236,378.788Z",
    transform: "translate(-65.353 -290.797)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "l",
    d: "M415.679,312.008s-12.782-.9-22.737,19.337c-9.938,20.238-17.9,35.81-17.9,35.81l-49.052-22.3-3.185,6.4s32.925,19.648,44.923,26.616,20.394-1.1,22.079-3.12,23.32-32.49,23.32-32.49Z",
    transform: "translate(-322.809 -283.351)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "m",
    d: "M329.911,384.392s-31.676-12.755-45.285-31.75c-9.751-13.608-5.475-34.517-5.475-34.517Z",
    transform: "translate(-199.841 -284.366)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "l",
    d: "M383.3,568.2l.072,5.962-5.055.007-.076-2.111-7.036,2.131-6.5,0s-.784-1.313.385-1.529c.323-.066,6.52-1.844,6.52-1.844l5.619-3.412Z",
    transform: "translate(-325.238 -325.684)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "l",
    d: "M104.652,446.536s19.541-8.859,28.65-32.48c4.034,9.724,3.706,39.495,3.215,55.225L203.884,431.8l.008.021,1.278-3.513,4.721,1.757-.664,2.008,7.335.443,6.071,2.409s.271,1.494-.9,1.3c-.333-.053-6.756-.678-6.756-.678l-5.952,1.594-3.437-3.2,2.856,3.581S151,488.109,148.459,490.29c-6.012,5.152-20.751,6.861-27.656-6.509l-.078-.04.036-.034c-.01-.014-.017-.038-.031-.05C113.349,469.152,113.489,469.528,104.652,446.536Z",
    transform: "translate(52.206 -300.267)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "n",
    d: "M276.509,393.342s-21.747-23.879-45.089-44.693C217.308,336.056,217.474,318,217.474,318s4.241-7.529,9.442-9.159c12.671-3.983,33.882,1.5,52.276,18.4,25.945,23.827,39.821,43.243,39.821,43.243l-13.814,13.2-24.92,9.548Z",
    transform: "translate(-138.268 -282.621)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "o",
    d: "M295.234,403.268s-5.3-11.41-15.694-14.714c-11.285-3.591-20.687-16.825-20.687-16.825a92.762,92.762,0,0,0,20.42,15.39,64.93,64.93,0,0,1,18.591,15.094Z",
    transform: "translate(-151.639 -293.251)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "o",
    d: "M243.056,379.412s8.422,6.02,24.294,11.529c3.837-2.59,5.946-3.838,8.821-4.685a42.106,42.106,0,0,1,6.231-1.195s-6.925-8.184-9.725-10.1a18.02,18.02,0,0,0-6.554-2.47l-15.063-.612Z",
    transform: "translate(-122.999 -293.275)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "l",
    d: "M176.377,304.066l43.417-19.572a33.8,33.8,0,0,1,19.9.5c11.091,6.077,59.948,29.964,59.948,29.964l-2.061,5.645L229.2,295.55s-14.3,17.077-30.672,25.583C185.425,321.744,176.377,304.066,176.377,304.066Z",
    transform: "translate(-84.607 -278.581)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "p",
    d: "M251.96,322.563a9.871,9.871,0,0,0-1.356,2.5,8.831,8.831,0,0,0,2.373,3.319s-.313,12.687,6.681,22.857c13.9,20.212,54.582,27.065,54.582,27.065l8.206-5.387-7.109-10.261s-35.917,2.752-50.628-16.154c-8.5-10.924-9.542-18.363-9.542-18.363a6.973,6.973,0,0,0,2.155-3.51A10.069,10.069,0,0,1,251.96,322.563Z",
    transform: "translate(-169.338 -285.102)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "l",
    d: "M336.3,382.291l-38.089,23.491-55.4,48.212L208,536.3l7.015,2.011s38.063-55.889,44.424-70.249c31.95-23.039,49.149-25.374,63.465-35.473C362.016,404.988,336.3,382.291,336.3,382.291Z",
    transform: "translate(-155.952 -295.002)"
  }), /*#__PURE__*/React.createElement("g", {
    transform: "translate(60.515)"
  }, /*#__PURE__*/React.createElement("path", {
    className: "q",
    d: "M351.3,306.295l-3.8-5.076-7.628-5.073s-2.143,6.1-2.434,9.751a6.756,6.756,0,0,1-5.005,5.662,82.737,82.737,0,0,0-8.3,1.781s9.866-.421,17.378,4.23C343.728,318.685,351.3,306.295,351.3,306.295Z",
    transform: "translate(-320.051 -280.723)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "k",
    d: "M340.86,310.747c2.93-.39,7.014-.559,9.41-1.148a4.866,4.866,0,0,0,3.557-4.417l1.23-6.2a7.775,7.775,0,0,0,2.1-2.285,2.462,2.462,0,0,0-1.9-3.6c-4.085-1.033-1.951-11.422-1.951-11.422l-5.567-.824-4.487,3.192-6.767,14.642s.018.8,1.019.8a20.2,20.2,0,0,1,2.293.183s.46,10.08.492,10.743C340.315,310.9,340.463,310.8,340.86,310.747Z",
    transform: "translate(-336.477 -278.187)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "l",
    d: "M351.016,295.037c.049.772.253.828,1.02.752.75-.085,1.823-.457,2.828-.618a26.6,26.6,0,0,0-3.527-1.35C350.625,293.553,350.942,294.22,351.016,295.037Z",
    transform: "translate(-345.945 -280.328)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "l",
    d: "M349.115,282.582c-14.164-6.24-19.577-6.06-20.537-2.185a3.6,3.6,0,0,0,.947,3.113c4.342-.972,8.532-1.472,7.661,1.629-.119.975-3.271,11.818.315,11.73.583-1.459,2.262-5.047,5.082-3.893,1.633.691.458,4.578,7.76,5.141C350.072,292.081,350.4,284.687,349.115,282.582Z",
    transform: "translate(-322.757 -277.659)"
  })), /*#__PURE__*/React.createElement("path", {
    className: "o",
    d: "M331.665,308.818l.692-.6-.8,13.194a12.628,12.628,0,0,1-8.421-1.356C328.041,316.482,331.665,308.818,331.665,308.818Z",
    transform: "translate(-239.763 -282.723)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "l",
    d: "M145.353,308.292s-3.432,43.807,49.019,49.991c97.7,11.508,100.229,19.078,100.229,19.078s-4.819-18.454-45.008-26.134C173,336.6,145.353,308.292,145.353,308.292Z",
    transform: "translate(-53.651 -282.736)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "l",
    d: "M306.145,361.128s-44.405-51.058-66.924-54.208c-14.12-1.975-23.993,1-23.993,1s3.856,27.307,36.549,39.249S306.145,361.128,306.145,361.128Z",
    transform: "translate(-123.526 -282.397)"
  }))))), /*#__PURE__*/React.createElement("g", {
    transform: "translate(738.719 158.373)"
  }, /*#__PURE__*/React.createElement("path", {
    className: "r",
    d: "M0,264.653,214.15,50.231S265.536-10.88,329.33,66.494c0,0,10.814,14.586,23.221,1.593,0,0,10.227-6.455-4.024-22.634,0,0-64.129-90.367-154.412-16.263L0,223.908Z",
    transform: "translate(0 520.627) rotate(-90)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "s",
    d: "M41.2,12.731,3.226,49.616s-8.131,8.634,1.425,20.37c0,0,10.311,7.293,20.119-1.928L54.7,37.293s28.753-25.4,52.561,4.443L336.528,270.923V231.775L137.435,32.683S110.778-.43,84.456.157C84.54.157,59.643-2.358,41.2,12.731Z",
    transform: "translate(36.578 336.528) rotate(-90)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "t",
    d: "M107.72,26.035,0,135.6l19.113,19.113L145.694,28.13,197,79.936s12.574,14.67,22.634,3.353c0,0,9.64-11.317-.419-18.861L169.585,14.8s-17.772-29.508-45.1-5.2Z",
    transform: "translate(77.176 402.209) rotate(-90)"
  })))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgCover1);
export default __webpack_public_path__ + "static/media/cover-1.8d724eb4f973b3327b0d7b95bd43a64c.svg";
export { ForwardRef as ReactComponent };